module.exports = __webpack_public_path__ + "assets/images/EURUNFIT50.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/EURUNFIT50.png
// module id = 1377
// module chunks = 1